import { useState } from "react";
import MenuAccordionCard from "@/pages/home/components/MenuAccordionCard";
import MenuQuickNav from "@/pages/home/components/MenuQuickNav";
import type { PonudbaKategorija } from "@/mocks/ponudbaMeni";

interface MenuAccordionProps {
  kategorije: PonudbaKategorija[];
}

/**
 * Menu shown as category cards. Clicking a card expands the full drink list.
 */
export default function MenuAccordion({ kategorije }: MenuAccordionProps) {
  const [odprte, setOdprte] = useState<string[]>(() =>
    kategorije[0] ? [kategorije[0].id] : [],
  );

  const preklopi = (id: string) => {
    setOdprte((prejsnje) =>
      prejsnje.includes(id)
        ? prejsnje.filter((element) => element !== id)
        : [...prejsnje, id],
    );
  };

  const vseOdprte = kategorije.every((kategorija) => odprte.includes(kategorija.id));

  const preklopiVse = () => {
    setOdprte(vseOdprte ? [] : kategorije.map((kategorija) => kategorija.id));
  };

  return (
    <div className="mt-9 md:mt-11">
      <div className="reveal mb-4 flex flex-wrap items-center justify-between gap-3 border-b border-background-300/70 pb-3">
        <p className="font-label text-[10px] uppercase tracking-[0.18em] text-foreground-400">
          Vseh {kategorije.length} kategorij · kliknite za seznam
        </p>
        <div className="flex flex-wrap items-center gap-3">
          <p className="flex items-center gap-2 font-label text-[10px] font-semibold uppercase tracking-[0.16em] text-accent-700">
            <i className="ri-information-line text-sm" />
            Cene so na voljo v lokalu
          </p>
          <span className="hidden h-3 w-px bg-background-300 sm:block" />
          <button
            type="button"
            onClick={preklopiVse}
            className="flex cursor-pointer items-center gap-2 rounded-full border border-background-300 px-3 py-1.5 font-label text-[9px] font-semibold uppercase tracking-[0.14em] text-foreground-600 transition-colors duration-300 hover:border-accent-500 hover:text-accent-800"
          >
            <i
              className={`${
                vseOdprte ? "ri-contract-up-down-line" : "ri-expand-up-down-line"
              } text-[13px]`}
            />
            {vseOdprte ? "Zapri vse" : "Odpri vse"}
          </button>
        </div>
      </div>

      <MenuQuickNav kategorije={kategorije} />

      <div className="columns-1 gap-3 md:columns-2 md:gap-4 xl:columns-3">
        {kategorije.map((kategorija) => (
          <div key={kategorija.id} className="mb-3 break-inside-avoid md:mb-4">
            <MenuAccordionCard
              kategorija={kategorija}
              odprto={odprte.includes(kategorija.id)}
              onToggle={preklopi}
            />
          </div>
        ))}
      </div>
    </div>
  );
}